import React, { useState } from "react";
import { formatarDataBrasil } from "../../utils/utils";
import "./PrevisaoRecebimentos.css";

export default function PrevisaoRecebimentos() {
    const [dataInicio, setDataInicio] = useState("");
    const [dataFim, setDataFim] = useState("");
    const [status, setStatus] = useState("TODOS");
    const [formaPagamento, setFormaPagamento] = useState("TODOS");
    const [totalPago, setTotalPago] = useState(0);
    const [totalPendente, setTotalPendente] = useState(0);
    const [totalReceita, setTotalReceita] = useState(0);
    const [cobrancas, setCobrancas] = useState([]);
    const [error, setError] = useState("");

    const buscarPrevisao = async () => {
        if (!dataInicio || !dataFim) {
            alert("Por favor, selecione um período válido.");
            return;
        }

        try {
            const response = await fetch(
                `https://welaunchyou.com.br/crm-wly/api/financeiro/previsao_recebimentos.php?data_inicio=${dataInicio}&data_fim=${dataFim}&status=${status}&forma_pagamento=${formaPagamento}`
            );
            const data = await response.json();

            if (data.error) {
                setError(data.error);
                return;
            }

            setTotalPago(data.total_pago);
            setTotalPendente(data.total_pendente);
            setTotalReceita(data.total_receita);
            setCobrancas(data.cobrancas);
            setError("");
        } catch (error) {
            console.error("Erro ao buscar previsão:", error);
            setError("Erro ao conectar com o servidor.");
        }
    };
    const atualizarStatus = async (id) => {
        try {
            const response = await fetch(
                `https://welaunchyou.com.br/crm-wly/api/financeiro/atualizar_status.php?id=${id}&status=PAGO`,
                { method: "POST" }
            );
            const data = await response.json();
    
            if (data.success) {
                alert("Status atualizado com sucesso!");
                buscarPrevisao(); // 🔄 Atualiza a lista após alteração
            } else {
                alert("Erro ao atualizar status.");
            }
        } catch (error) {
            console.error("Erro ao atualizar status:", error);
            alert("Erro ao conectar ao servidor.");
        }
    };

    const exportarDados = (tipo) => {
        window.open(
            `https://welaunchyou.com.br/crm-wly/api/financeiro/exportar_previsao.php?data_inicio=${dataInicio}&data_fim=${dataFim}&status=${status}&forma_pagamento=${formaPagamento}&tipo=${tipo}`,
            "_blank"
        );
    };
    
    

    return (
        <div>
            <h1 className="previsao-titulo">Previsão de Recebimentos</h1>
    
            <div className="previsao-container">
    
                {/* Filtros */}
                <div className="previsao-filtros">
                    <label>Data Início:</label>
                    <input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
    
                    <label>Data Fim:</label>
                    <input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
    
                    <label>Status:</label>
                    <select value={status} onChange={(e) => setStatus(e.target.value)}>
                        <option value="TODOS">Todos</option>
                        <option value="PAGO">Pago</option>
                        <option value="COBRADO">Cobrado</option>
                    </select>
    
                    <label>Forma de Pagamento:</label>
                    <select value={formaPagamento} onChange={(e) => setFormaPagamento(e.target.value)}>
                        <option value="TODOS">Todos</option>
                        <option value="PIX">PIX</option>
                        <option value="BOLETO">Boleto</option>
                        <option value="CARTAO">Cartão</option>
                    </select>
    
                    <button onClick={buscarPrevisao} className="previsao-botao">Buscar</button>
                </div>
    
                {error && <p className="previsao-error">{error}</p>}
    
                {/* Bloco PAGOS */}
                {cobrancas.some(c => c.status === "PAGO") && (
                    <>
                        <h2 style={{ borderBottom: "none" }} className="bloco-subtitulo">Recebimentos Confirmados</h2>
                        <table className="previsao-tabela">
                            <thead>
                                <tr>
                                    <th>Cliente</th>
                                    <th>Vencimento</th>
                                    <th>Valor</th>
                                    <th>Forma de Pagamento</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cobrancas
                                    .filter(c => c.status === "PAGO")
                                    .map((cobranca, index) => (
                                        <tr key={`pago-${index}`}>
                                            <td>{cobranca.cliente_nome}</td>
                                            <td>{formatarDataBrasil(cobranca.vencimento)}</td>
                                            <td>R$ {parseFloat(cobranca.valor).toFixed(2)}</td>
                                            <td>{cobranca.tipo_pagamento}</td>
                                            <td className="status-pago">PAGO</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </>
                )}
    
                {/* Bloco COBRADOS */}
                {cobrancas.some(c => c.status === "COBRADO") && (
                    <>
                        <h2 style={{ borderBottom: "none" }} className="bloco-subtitulo">Previsões a Receber</h2>
                        <table className="previsao-tabela">
                            <thead>
                                <tr>
                                    <th>Cliente</th>
                                    <th>Vencimento</th>
                                    <th>Valor</th>
                                    <th>Forma de Pagamento</th>
                                    <th>Status</th>
                                    <th>Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cobrancas
                                    .filter(c => c.status === "COBRADO")
                                    .map((cobranca, index) => {
                                        const hoje = new Date();
                                        const vencimento = new Date(cobranca.vencimento);
                                        const diferencaDias = Math.ceil((vencimento - hoje) / (1000 * 60 * 60 * 24));
    
                                        let classeLinha = "";
                                        if (diferencaDias < 0) {
                                            classeLinha = "vencido";
                                        } else if (diferencaDias <= 3) {
                                            classeLinha = "proximo-vencimento";
                                        }
    
                                        return (
                                            <tr key={`previsto-${index}`} className={classeLinha}>
                                                <td>{cobranca.cliente_nome}</td>
                                                <td>{formatarDataBrasil(cobranca.vencimento)}</td>
                                                <td>R$ {parseFloat(cobranca.valor).toFixed(2)}</td>
                                                <td>{cobranca.tipo_pagamento}</td>
                                                <td className={`status-${cobranca.status.toLowerCase()}`}>{cobranca.status}</td>
                                                <td>
                                                    {cobranca.id && (
                                                        <button
                                                            className="botao-atualizar"
                                                            onClick={() => atualizarStatus(cobranca.id)}
                                                        >
                                                            Marcar como Pago
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </>
                )}
    
                {/* Resultados totais */}
                <div className="previsao-resultados">
                    <h3>Total Pago: R$ {parseFloat(totalPago).toFixed(2)}</h3>
                    <h3>Total Pendente: R$ {parseFloat(totalPendente).toFixed(2)}</h3>
                    <h3 style={{ fontWeight: "bold", color: "#28a845" }}>
                        Total Receita: R$ {parseFloat(totalReceita).toFixed(2)}
                    </h3>
                </div>
    
                {/* Exportar */}
                <div className="previsao-exportar">
                    <button onClick={() => exportarDados("pdf")} className="botao-exportar">Exportar PDF</button>
                </div>
            </div>
        </div>
    );
}
